export default "__VITE_PUBLIC_ASSET__eb569554__"